import { z } from 'zod/v4'

export const statementSearchSchema = z.object({
  cutoff_date: z.iso.date().optional().catch(undefined),
  search: z.string().max(100).optional().catch(undefined),
  overdue_only: z
    .union([z.literal(true), z.literal(1), z.literal('1'), z.literal('true')])
    .transform(() => true)
    .catch(false),
  delivery_method: z.enum(['preferences', 'automatic', 'email', 'print']).catch('preferences'),
  page: z.coerce.number().int().positive().catch(1),
  history_page: z.coerce.number().int().positive().catch(1),
  run_id: z.coerce.number().int().positive().optional().catch(undefined),
})

export type StatementSearch = z.infer<typeof statementSearchSchema>

/** The candidates request: the URL search without the run history page or the open run. */
export type StatementCandidateFilters = Omit<StatementSearch, 'history_page' | 'run_id'>

/** Which customers a run includes: the picked ids, or every match except the excluded ids. */
export interface StatementSelection {
  all_matching: boolean
  customer_ids: number[]
  excluded_ids: number[]
}

export const emptyStatementSelection = (): StatementSelection => ({
  all_matching: false,
  customer_ids: [],
  excluded_ids: [],
})
export function isStatementSelected(selection: StatementSelection, id: number): boolean {
  return selection.all_matching
    ? !selection.excluded_ids.includes(id)
    : selection.customer_ids.includes(id)
}
export function toggleStatementSelection(
  selection: StatementSelection,
  id: number
): StatementSelection {
  const key = selection.all_matching ? 'excluded_ids' : 'customer_ids'
  const ids = selection[key]
  return {
    ...selection,
    [key]: ids.includes(id) ? ids.filter((value) => value !== id) : [...ids, id],
  }
}
